var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRequests({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "02-requests",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    width: 64,
    height: 64
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M35.2,3.8c-0.8-0.8-2-1.3-3.2-1.3c-1.2,0-2.3,0.5-3.2,1.3h0L18.5,14.1c0.4,0.4,0.9,0.7,1.5,1c0.5,0.2,1.1,0.3,1.7,0.3 c0.6,0,1.2-0.1,1.7-0.3c0.5-0.2,1-0.6,1.5-1l4.9-4.9v21.5h4.5V9.2l4.9,4.9c0.4,0.4,0.9,0.7,1.5,1c0.5,0.2,1.1,0.3,1.7,0.3 c0.6,0,1.2-0.1,1.7-0.3c0.5-0.2,1-0.6,1.5-1L35.2,3.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M53.4,20.7H38.7v4.5h14.7c2,0,3.6,1.6,3.6,3.6v24.7c0,2-1.6,3.6-3.6,3.6H10.6c-2,0-3.6-1.6-3.6-3.6V28.7 c0-2,1.6-3.6,3.6-3.6h14.7v-4.5H10.6c-4.5,0-8.1,3.6-8.1,8.1v24.7c0,4.5,3.6,8.1,8.1,8.1h42.9c4.5,0,8.1-3.6,8.1-8.1V28.7 C61.5,24.3,57.9,20.7,53.4,20.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 13.1,
    y: 46.5,
    width: 37.8,
    height: 4.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequests);
export default __webpack_public_path__ + "static/media/requests.ad6e5486ee94fbd099783c8d59641e3c.svg";
export { ForwardRef as ReactComponent };